import gql from 'graphql-tag'

export const SINCRONIZAR_IDENTITY_PROVIDER = gql`
  mutation SincronizarIdentityProvider($emailUsuario: String!) {
    sincronizarIdentityProvider(emailUsuario: $emailUsuario)
  }
`
